<template>
  <li :class="listItemClasses">
    <div :class="circleClasses">
      <svg v-if="vote" class="vink" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13.31"><path d="M4.17 12.83L.48 9.13a1.64 1.64 0 0 1 0-2.32 1.64 1.64 0 0 1 2.32 0l2.53 2.54L14.2.48a1.64 1.64 0 0 1 2.32 0 1.64 1.64 0 0 1 0 2.32l-10 10a1.64 1.64 0 0 1-2.35.03z" fill="#fff"/></svg>
      <div v-else class="close"></div>
    </div>
    <div class="content">
      <h3 class="year">{{ year }}</h3>
      <p><slot></slot></p>
    </div>
  </li>
</template>

<script>
export default {
  name: 'VoteListItem',
  props: {
    year: {
      type: Number,
      required: true
    },
    vote: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    listItemClasses () {
      return {
        'vote-list-item': true,
        'active': this.vote
      }
    },
    circleClasses () {
      return {
        'circle': true,
        'non-vote': !this.vote
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vote-list-item {
  @extend %clearfix;

  border-radius: 10px;
  padding: 12px 18px;
  background: rgba(#212121, 0.1);
  color: white;
  margin: 0 auto 7px;
  font-size: 16px;
  position: relative;
}

.active {
  background-color: #00696E;
}

.content {
  padding-left: 52px;
  min-height: 36px;
}

.year {
  font-weight: $fw-semi;
}

.circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: $c-blue;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.non-vote {
  background-color: #E61E14;
}

.vink {
  width: 20px;
  height: 16px;
  position: absolute;
  left: 9px;
  top: 12px;
}

.close {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &::before,
  &::after {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    content: ' ';
    height: 18px;
    width: 3px;
    border-radius: 3px;
    background-color: white;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}
</style>
